export default __webpack_public_path__ + "static/flow-poster-image-meesman-d804e9e5597207fc16a036126affe21f.png";